import { Paper, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Exercises } from "app-interfaces";
import React from "react";

import { useStateValue } from "../../../config/AppContext";
import Icons from "../../Utilities/Icons";

interface ExerciseListItemProps {
  exercise: Exercises.IExercise;
  onClick: (exercise: Exercises.IExercise) => void;
}

const useStyles = makeStyles((theme) => ({
  exerciseItemPaper: {
    // display: 'grid',
    // gridTemplateColumns: '1fr 2fr',
    padding: "8px",
    // marginBottom: '5px',
    cursor: "pointer",
    boxShadow: "0px 0px 14px -4px rgba(0, 3, 12, 0.1)",
    marginBottom: 1,
  },
  exerciseItemToolTipContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    textTransform: "capitalize",
    padding: "0 1rem",
  },
  exerciseItemToolTipPara: {
    margin: 0,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  exerciseItemPara: {
    fontSize: "12px",
    margin: 0,
    left: "40%",
    color: "#6c757d",
  },
  selectedExerciseItemImg: {
    borderRadius: "50%",
    backgroundColor: "var(--text-primary)",
    height: "15px",
    marginBottom: "2px",
  },
}));

const ExerciseListItem: React.FC<ExerciseListItemProps> = ({ exercise, onClick }) => {
  const { id, photo_start, name, type, focus_prim } = exercise;
  const { ic_placeholder, ic_info } = Icons;
  const classes = useStyles();
  const { catalog } = useStateValue();

  return (
    <Paper
      key={id}
      id={id}
      onClick={() => onClick(exercise)}
      className={`meraCard ${classes.exerciseItemPaper}`}
    >
      <div style={{ width: "97px", padding: "5px" }}>
        <img
          loading="lazy"
          src={photo_start ? photo_start.small : ic_placeholder}
          alt="exercises"
          style={{
            height: !/exercises/.test(window.location.href) ? 88 : 65,
          }}
          onError={(event) => {
            event.currentTarget.src = ic_placeholder;
            event.currentTarget.onerror = null;
            return true;
          }}
        />
      </div>
      <div className={classes.exerciseItemToolTipContainer}>
        <div style={{ width: "56%" }}>
          <Tooltip title={name} disableHoverListener={name.length < 16}>
            <p
              style={{
                width: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? "28vw" : "15vw",
              }}
              className={classes.exerciseItemToolTipPara}
            >
              {name}
            </p>
          </Tooltip>
          <p style={{ fontSize: "14px", margin: 0, color: "#6c757d" }}>
            {catalog && catalog.typesDisplay(type.toString()).toLowerCase()}
          </p>
        </div>
        <p
          // style={{
          //   position: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
          //     ? 'inherit'
          //     : 'absolute',
          // }}
          className={classes.exerciseItemPara}
        >
          <span
            style={{
              height: "15px",
              marginRight: "5px",
            }}
          >
            <img alt="info" src={ic_info} className={classes.selectedExerciseItemImg} />
          </span>
          {focus_prim ? catalog.typesDisplay(focus_prim.toString()).toLowerCase() : "None"}
        </p>
        <div>
          <ArrowForwardIosIcon style={{ fontSize: 14, color: "#6c757d" }} />
        </div>
      </div>
    </Paper>
  );
};

export default ExerciseListItem;
